
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { useTheme,styled } from '@mui/material/styles';
//
import { BaseOptionChart } from '../../dash_charts/BaseOptionChart'
import { Typography } from '@mui/material';

// ----------------------------------------------------------------------

var pt = require("apexcharts/dist/locales/pt.json");

const CHART_HEIGHT = 250;
const LEGEND_HEIGHT = 25;

const ChartWrapperStyle = styled('div')(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(0),
  '& .apexcharts-canvas svg': {
    height: CHART_HEIGHT
  },
  '& .apexcharts-canvas svg,.apexcharts-canvas foreignObject': {
    overflow: 'visible'
  },
  '& .apexcharts-legend': {
    height: LEGEND_HEIGHT,
    alignContent: 'center',
    position: 'relative !important',
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`
  }
}));
// ----------------------------------------------------------------------

const CHART_DATA = [
  { name: 'Máximo', data: [120, 70, 40, 80, 120, 90] },
  { name: 'Média', data: [80, 50, 30, 40, 100, 20] },
  
  //{ name: 'Instrução #3', data: [44, 76, 78, 13, 43, 10] }
];

export default function AmplitudesArticularesExercicio() {
  const theme = useTheme();

  const chartOptions = merge(BaseOptionChart(), {
    
    stroke: { width: 3},
    fill: { opacity: [0.1,0.3] },
    legend: { floating: true, horizontalAlign: 'center' },
    markers: {
        size: 5
    },
    colors: [
      theme.palette.primary.light,
      theme.palette.primary.main,
    ],
    chart: {
        locales: [pt],
        defaultLocale: 'pt',
        type: 'radar',
        toolbar: { show: false },
        dropShadow: {
          enabled: true,
          blur: 1,
          left: 1,
          top: 1
        }
    },
    
    xaxis: {
      categories: ['Tornozelo', 'Joelho', 'Tronco', 'Braço', 'Cabeça', 'Mão'],
      labels: {
        style: {
          colors: [
            theme.palette.text.secondary,
          ]
        }
      }
    }
  });

  return (
    
    <Typography variant="h6">Amplitudes Articulares
        <ChartWrapperStyle dir="ltr">
            <ReactApexChart type="radar" series={CHART_DATA} options={chartOptions} height={250} />  
        </ChartWrapperStyle>
    </Typography>
  );
}

